import moment from "moment";
import {
  capitalizeWordsSeperatedByUnderScore,
  isValidString,
} from "../../../../utils/stringModifications";
import AssistSessionScreenshotButton from "./assistSessionScreenshotButton";
import { buildActionLabel } from "./assistSessionViewer.helpers";
import { AssistActionMetadata } from "./assistSessionViewer.types";

interface AssistSessionActionRowProps {
  timestamp?: string;
  metadata: AssistActionMetadata;
}

/**
 * Renders a browser action that belongs to no question as a compact row.
 *
 * Actions recorded while answering a question are shown inside the question
 * entry instead; this row only covers the ones that stand on their own.
 *
 * @param props - Timestamp and action metadata of the audit entry
 * @returns The action row element
 */
const AssistSessionActionRow = (props: AssistSessionActionRowProps) => {
  const { action_type, action_value, tab, screenshot_path } = props.metadata;
  const label = buildActionLabel(
    capitalizeWordsSeperatedByUnderScore(action_type ?? ""),
    tab,
    action_value,
  );

  return (
    <div className="assist-action-row--container flex items-center gap-3 py-2.5">
      {isValidString(screenshot_path) ? (
        <AssistSessionScreenshotButton
          label={label}
          screenshotPath={screenshot_path ?? ""}
        />
      ) : (
        <div className="action-label flex-1 truncate text-tiny text-primaryGray-7">
          {label}
        </div>
      )}
      <div
        className="timestamp ml-auto whitespace-nowrap text-x-tiny text-primaryGray-10"
        title={moment(props.timestamp).format("MM/DD/YYYY HH:mm:ss")}
      >
        {moment(props.timestamp).format("HH:mm")}
      </div>
    </div>
  );
};

export default AssistSessionActionRow;
